<template lang="pug">
#app
  v-app
    side-bar
    v-main(:style="!$vuetify.theme.dark ? `background: ${$vuetify.theme.themes.light.background}` : ''", transition="slide-y-transition")
      router-view
    notifications(position='top right', :class="isMovil ? 'width-full' : ''")
      template(slot='body' slot-scope='props')
        v-alert.elevation-2.py-3.ma-1.animated.fadeInRight.faster(dense border="left" :type='props.item.type')
          v-row(align='center')
            v-col.grow
              small.font-size-11.font-weight-700 {{props.item.text}}
    loading-transaction(v-if="transaction.isProceso" :label="transaction.message")
</template>

<script>
  import { apiGet, notify } from './util/general'
  import sideBar from './views/View_sidebar'
  import loadingTransaction from '@/components/c_loading_transaction'
  export default {
    name      : 'dispatcherApp',
    components: {
      'side-bar'           : sideBar,
      'loading-transaction': loadingTransaction
    },
    data () {
      return {
        empresa    : process.env.EMPRESA,
        empresaFull: process.env.EMPRESA_FULL,
        usuario    : localStorage.getItem('username'),
        isLoading  : false
      }
    },
    created () {
      var vm = this
      vm.fetchGetDataUser()
    },
    computed : {
      transaction () {
        var vm = this
        return vm.$store.state.app.transaction
      },
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      },
      scrollbarTheme () {
        var vm = this
        return vm.$vuetify.theme.dark ? 'dark-scroll' : 'light-scroll';
      }
    },
    methods: {
      fetchGetDataUser () {
        var vm = this
        vm.isLoading = true
        var obj      = {
          usuario : vm.usuario
        }
        apiGet(vm, '/usuario/obtener', obj, function (data) {
          var usuario = data.lista[0]
          if (usuario.configuracionesApp) {
            var configs = JSON.parse(usuario.configuracionesApp)
            vm.$store.dispatch('setSettings', configs)
            vm.$vuetify.theme.dark = configs.general.theme.dark
          }
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
        }, () => {
          vm.isLoading = true
        })
      }
    }
  }
</script>

<style lang="stylus">
@import '~animate.css';
@import "./assets/css/main.styl"
.line-height-title
  line-height: 11px;
</style>



// WEBPACK FOOTER //
// Dispatcher_App.vue?fdc9b6d4